$(document).on('shopify:section:load', function() {   

    if ($('.story-mission').length) {
        $('.story-mission .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberSM() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
                let random4 = randomNumberWithDigits(digitCount);
                let random5 = randomNumberWithDigits(digitCount);
                let random6 = randomNumberWithDigits(digitCount);
                let random7 = randomNumberWithDigits(digitCount);
                let random8 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${random4}</span>
                    <span>${random5}</span>
                    <span>${random6}</span>
                    <span>${random7}</span>
                    <span>${random8}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberSM() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 300);
            }
        
            $this.data('randomNumberSM', randomNumberSM);
            $this.data('animateNumberSM', animateNumberSM);
        
            randomNumberSM();

        });
    }

    if ($('.toggle-text-image').length) {
        $('.toggle-text-image .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
            let owl = '';

            if (wSize >= 1280) {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    smartSpeed: 300,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: false,
                    stagePadding: 0,
                    margin: 20,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                });
            }
            else {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    smartSpeed: 300,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: false,
                    stagePadding: 0,
                    margin: 20,
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                });
            }

            setTimeout(() => {
                let img_h = $carousel.find('.image-container').height() / 2;
                $floatNav.css('top', `${img_h}px`);
            }, 500);

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
        });
    }

    if ($('.milestones').length) {
        $('.milestones .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
            let owl = '';

            let autoPlayTime = $(this).data('autoplay') * 1000;
            let isAutoplay = $(this).data('autoplay') > 0;

            if (wSize >= 1280) {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: true,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    stagePadding: 0,
                    margin: 20,
                    autoplay: isAutoplay,
                    autoplayTimeout: autoPlayTime,
                    autoplayHoverPause: false,
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                }).on('changed.owl.carousel', function(event) {
                    setTimeout(() => {
                        slide = $carousel.find('.owl-item.active [data-slide]').data('slide');
                        $carousel.parents('.milestones').find(`.date[data-date="${slide}"]`).trigger('click');

                        let $container = $carousel.parents('.milestones').find('.container .dates');
                        let $active = $container.find('.date.active');

                        if ($active.length === 0) return;

                        let containerLeft = $container.scrollLeft();

                        let activeLeft = $active.position().left;
                        let activeRight = activeLeft + $active.outerWidth();

                        if (activeLeft < 0 || activeRight > $container.outerWidth()) {
                            $container.animate({
                                scrollLeft: containerLeft + activeLeft - 20
                            }, 0);
                        }

                    }, 50);
                });
            }
            else {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: true,
                    stagePadding: 0,
                    margin: 20,
                    autoplay: isAutoplay,
                    autoplayTimeout: autoPlayTime,
                    autoplayHoverPause: false,
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                }).on('changed.owl.carousel', function(event) {
                    setTimeout(() => {
                        slide = $carousel.find('.owl-item.active [data-slide]').data('slide');
                        $carousel.parents('.milestones').find(`.date[data-date="${slide}"]`).trigger('click');

                        let $container = $carousel.parents('.milestones').find('.mobile-container .dates');
                        let $active = $container.find('.date.active');

                        if ($active.length === 0) return;

                        let containerLeft = $container.scrollLeft();

                        let activeLeft = $active.position().left;
                        let activeRight = activeLeft + $active.outerWidth();

                        if (activeLeft < 0 || activeRight > $container.outerWidth()) {
                            $container.animate({
                                scrollLeft: containerLeft + activeLeft - 20
                            }, 0);
                        }

                    }, 50);
                });
            }

            setTimeout(() => {
                let img_h = $carousel.find('.image-container').height() / 2;
                $floatNav.css('top', `${img_h}px`);
            }, 500);

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            let datesContainer = $(this).parents('.milestones').find('.dates');
            datesContainer.find('.active').trigger('click');
        });
    }

    if ($('.categorized-slider').length) {
        $('.categorized-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: $carousel.find('.item').length > 1 ? true:false,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        stagePadding: 30
                    },
                    1280: {
                        stagePadding: 0
                    }
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });

        $('.categorized-slider').each(function() {
            let el = $(this);

            el.find('.mobile-container .category').first('trigger').click();
            el.find('.container .category').first('trigger').click();
        });
    }

    if ($('.distributor-map').length) {
        $('.distributor-map .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberDM() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
                let random4 = randomNumberWithDigits(digitCount);
                let random5 = randomNumberWithDigits(digitCount);
                let random6 = randomNumberWithDigits(digitCount);
                let random7 = randomNumberWithDigits(digitCount);
                let random8 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${random4}</span>
                    <span>${random5}</span>
                    <span>${random6}</span>
                    <span>${random7}</span>
                    <span>${random8}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberDM() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 300);
            }
        
            $this.data('randomNumberDM', randomNumberDM);
            $this.data('animateNumberDM', animateNumberDM);
        
            randomNumberDM();

        });
    }

    scroll_video_effect();
    story_mission();
    toggle_text_image();
    milestones();
    categorized_slider();
    two_column();
    distributor_map();
    retailers();

    milestone_dates();
    categorized_cat();

});

$(document).ready(function() {   

    if ($('.story-mission').length) {
        $('.story-mission .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberSM() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
                let random4 = randomNumberWithDigits(digitCount);
                let random5 = randomNumberWithDigits(digitCount);
                let random6 = randomNumberWithDigits(digitCount);
                let random7 = randomNumberWithDigits(digitCount);
                let random8 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${random4}</span>
                    <span>${random5}</span>
                    <span>${random6}</span>
                    <span>${random7}</span>
                    <span>${random8}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberSM() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 300);
            }
        
            $this.data('randomNumberSM', randomNumberSM);
            $this.data('animateNumberSM', animateNumberSM);
        
            randomNumberSM();

        });
    }

    if ($('.toggle-text-image').length) {
        $('.toggle-text-image .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
            let owl = '';

            if (wSize >= 1280) {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    smartSpeed: 300,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: false,
                    stagePadding: 0,
                    margin: 20,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                });
            }
            else {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    smartSpeed: 300,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: false,
                    stagePadding: 0,
                    margin: 20,
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                });
            }

            setTimeout(() => {
                let img_h = $carousel.find('.image-container').height() / 2;
                $floatNav.css('top', `${img_h}px`);
            }, 500);

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });
        });
    }

    if ($('.milestones').length) {
        $('.milestones .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');
            let owl = '';

            if (wSize >= 1280) {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: true,
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    stagePadding: 0,
                    margin: 20,
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                }).on('changed.owl.carousel', function(event) {
                    setTimeout(() => {
                        slide = $carousel.find('.owl-item.active [data-slide]').data('slide');
                        $carousel.parents('.milestones').find(`.date[data-date="${slide}"]`).trigger('click');

                        let $container = $carousel.parents('.milestones').find('.container .dates');
                        let $active = $container.find('.date.active');

                        if ($active.length === 0) return;

                        let containerLeft = $container.scrollLeft();

                        let activeLeft = $active.position().left;
                        let activeRight = activeLeft + $active.outerWidth();

                        if (activeLeft < 0 || activeRight > $container.outerWidth()) {
                            $container.animate({
                                scrollLeft: containerLeft + activeLeft - 20
                            }, 0);
                        }

                    }, 50);
                });
            }
            else {
                owl = $carousel.owlCarousel({
                    items: 1,
                    nav: false,
                    dots: false,
                    autoHeight: true,
                    mouseDrag: false,
                    touchDrag: false,
                    loop: true,
                    stagePadding: 0,
                    margin: 20,
                    responsive: {
                        0: {
                            loop: true,
                            stagePadding: 30
                        },
                        1280: {
                            loop: false,
                            stagePadding: 0
                        }
                    }
                }).on('changed.owl.carousel', function(event) {
                    setTimeout(() => {
                        slide = $carousel.find('.owl-item.active [data-slide]').data('slide');
                        $carousel.parents('.milestones').find(`.date[data-date="${slide}"]`).trigger('click');

                        let $container = $carousel.parents('.milestones').find('.mobile-container .dates');
                        let $active = $container.find('.date.active');

                        if ($active.length === 0) return;

                        let containerLeft = $container.scrollLeft();

                        let activeLeft = $active.position().left;
                        let activeRight = activeLeft + $active.outerWidth();

                        if (activeLeft < 0 || activeRight > $container.outerWidth()) {
                            $container.animate({
                                scrollLeft: containerLeft + activeLeft - 20
                            }, 0);
                        }

                    }, 50);
                });
            }

            setTimeout(() => {
                let img_h = $carousel.find('.image-container').height() / 2;
                $floatNav.css('top', `${img_h}px`);
            }, 500);

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            let datesContainer = $(this).parents('.milestones').find('.dates');
            datesContainer.find('.active').trigger('click');
        });
    }

    if ($('.categorized-slider').length) {
        $('.categorized-slider .owl-carousel').each(function() {
            let $carousel = $(this);
            let $floatNav = $carousel.next('.float-nav');

            let owl = $carousel.owlCarousel({
                items: 1,
                nav: false,
                dots: true,
                loop: $carousel.find('.item').length > 1 ? true:false,
                margin: 20,
                stagePadding: 0,
                responsive: {
                    0: {
                        stagePadding: 30
                    },
                    1280: {
                        stagePadding: 0
                    }
                }
            });

            $floatNav.find('.owl-prev').on('click', function() {
                owl.trigger('prev.owl.carousel');
            });
            $floatNav.find('.owl-next').on('click', function() {
                owl.trigger('next.owl.carousel');
            });

            $(this).trigger('refresh.owl.carousel');
        });

        $('.categorized-slider').each(function() {
            let el = $(this);

            el.find('.mobile-container .category').first('trigger').click();
            el.find('.container .category').first('trigger').click();
        });
    }

    if ($('.distributor-map').length) {
        $('.distributor-map .count span').each(function () {
            let $this = $(this);
            
            let $countElement = $this.find('.count-it');
            let originalNumber = parseInt($countElement.text());
        
            $this.data('countElement', $countElement);
            $this.data('originalNumber', originalNumber);

            function randomNumberWithZeros(digits) {
                return "0".repeat(digits);
            }
        
            function randomNumberWithDigits(digits) {
                let min = Math.pow(10, digits - 1);
                let max = Math.pow(10, digits) - 1;
                return Math.floor(Math.random() * (max - min + 1)) + min;
            }
        
            function randomNumberDM() {
                let digitCount = originalNumber.toString().length;
                let random1 = randomNumberWithZeros(digitCount);
                let random2 = randomNumberWithDigits(digitCount);
                let random3 = randomNumberWithDigits(digitCount);
                let random4 = randomNumberWithDigits(digitCount);
                let random5 = randomNumberWithDigits(digitCount);
                let random6 = randomNumberWithDigits(digitCount);
                let random7 = randomNumberWithDigits(digitCount);
                let random8 = randomNumberWithDigits(digitCount);
        
                $countElement.html(`
                    <span>${random1}</span>
                    <span>${random2}</span>
                    <span>${random3}</span>
                    <span>${random4}</span>
                    <span>${random5}</span>
                    <span>${random6}</span>
                    <span>${random7}</span>
                    <span>${random8}</span>
                    <span>${originalNumber}</span>
                `);
            }
        
            function animateNumberDM() {
                setTimeout(() => {
                    $countElement.find('span').addClass('active');
                }, 300);
            }
        
            $this.data('randomNumberDM', randomNumberDM);
            $this.data('animateNumberDM', animateNumberDM);
        
            randomNumberDM();

        });
    }

    scroll_video_effect();
    story_mission();
    toggle_text_image();
    milestones();
    categorized_slider();
    two_column();
    distributor_map();
    retailers();
    
    milestone_dates();
    categorized_cat();

});

$(window).scroll(function() {
    scroll_video_effect();
    story_mission();
    toggle_text_image();
    milestones();
    categorized_slider();
    two_column();
    distributor_map();
    retailers();
});

$(window).resize(function() {
    milestone_dates();
    categorized_cat();
});

function scroll_video_effect() {
    if ($('.scroll-video-effect').length) {
        $('.scroll-video-effect').each(function() {
            let el = $(this);
            let headerH = $('nav.header').height();

            let elTop = el.offset().top;
            let scrollTop = $(window).scrollTop();

            if (scrollTop >= elTop) {
                el.find('.scroll-it p').css('top', '100px');
            } 
            else {
                el.find('.scroll-it p').css('top', '0');
            }

            el.find('.sticky').css({
                height: $(window).height() - headerH + 'px',
                top: headerH + 'px'
            });

            //subtitle
            if (visiblePercent(el) > 35) {
                el.find('.subtitle .show-up').removeClass('show').addClass('hide');
            }
            else {
                el.find('.subtitle .show-up').removeClass('hide').addClass('show');
            }
            
            //mask
            let scale = 0;
            let opacity = 1
            if (visiblePercent(el) <= 35) {
                scale = 0;
                opacity = 1;
            } 
            else if (visiblePercent(el) >= 55) {
                scale = 3;
                opacity = 0;
            } 
            else {
                scale = ((visiblePercent(el) - 35) / (55 - 35)) * 3;
                opacity = 1 - ((visiblePercent(el) - 35) / (55 - 35));
            }

            el.find('.mask').css({
                opacity: opacity,
                transform: `translate(-50%, -50%) scale(${1 + scale})`
            });

            //description
            if (visiblePercent(el) > 70) {
                el.find('.container .show-up').addClass('show').removeClass('hide');
            } 
            /* else if (visiblePercent(el) < 70 && visiblePercent(el) > 65) {
                el.find('.container .show-up').removeClass('show').addClass('hide');
            } */
            else {
                el.find('.container .show-up').removeClass('show').removeClass('hide');
            }
        });
    }
}

function story_mission() {
    if ($('.story-mission').length) {
        $('.story-mission').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 50) {
                el.find('.aos-init').addClass('aos-animate');
                
                setTimeout(() => {
                    el.find('.count span').each(function () {
                        let $this = $(this);
                        if (!$this.data('hasAnimated') && $this.data('randomNumberSM') && $this.data('animateNumberSM')) {
                            $this.data('randomNumberSM')();
                            $this.data('animateNumberSM')();
                            $this.data('hasAnimated', true);
                        }
                    });
                }, 800);
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }

        });    
    }
}

function toggle_text_image() {
    if ($('.toggle-text-image').length) {
        $('.toggle-text-image').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }

        });    
    }
}

function milestones() {
    if ($('.milestones').length) {
        $('.milestones').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');

                let autoPlayTime = el.find('.owl-carousel').data('autoplay') * 1000;
                let isAutoplay = el.find('.owl-carousel').data('autoplay') > 0;

                if (isAutoplay) {}
                    el.find('.owl-carousel').trigger('play.owl.autoplay', [autoPlayTime]);
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }

        });    
    }
}

function categorized_slider() {
    if ($('.categorized-slider').length) {
        $('.categorized-slider').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }

        });    
    }
}

function retailers() {
    if ($('.retailers').length) {
        $('.retailers').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 30) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }

        });    
    }
}

$('.toggle-text-image .text').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');

    let index = $(this).index();
    let owl = $(this).parents('.toggle-text-image').find('.owl-carousel');

    owl.trigger('to.owl.carousel', index);
});

$('.milestones .dates .date').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');

    let index = $(this).index();
    let owl = $(this).parents('.milestones').find('.owl-carousel');

    owl.trigger('to.owl.carousel', index);

    let innerline = $(this).parents('.dates').find('.innerline');
    let lastDate = $(this).parents('.dates').find('.date').last();
    
    if (wSize >= 1280) {
        if ($(this).is(lastDate)) {
            innerline.css('width', '100%');
        } 
        else {
            let activeCenter = ($(this).position().left + $(this).outerWidth() / 2) + 6;
            innerline.css('width', activeCenter + 'px');
        }
    }
    else {
        let thisIndex = $(this).index();
        let innerLine = 0;
        let $dates = $(this).parents('.dates').find('.date');

        $dates.each(function(index) {
            if (index == thisIndex) {
                innerLine += ($(this).width() / 2) + 6;
                return false
            }
            else {
                innerLine += $(this).width();
            }
        });

        for (let i = 0; i < thisIndex; i++) {
            let $current = $($dates[i]);
            let $next = $($dates[i + 1]);

            let currentRight = $current.offset().left + $current.outerWidth();
            let nextLeft = $next.offset().left;

            let space = nextLeft - currentRight;
            innerLine += space;
        }

        if ($(this).is(lastDate)) {
            innerline.css('width', '100%');
        }
        else {
            innerline.css('width', `${innerLine}px`);
        }
    }
});

$('.categorized-slider .category').on('click', function() {
    $(this).addClass('active').siblings().removeClass('active');

    let cat = $(this).data('cat');
    $(this).parents('.categorized-slider').find(`.slide[data-slide="${cat}"]`).fadeIn().siblings().hide();
});

function two_column() {
    if ($('.two-column').length) {
        $('.two-column').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }

        });    
    }
}

function distributor_map() {
    if ($('.distributor-map').length) {
        $('.distributor-map').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 80) {
                el.find('.count span').each(function () {
                    let $this = $(this);
                    if (!$this.data('hasAnimated') && $this.data('randomNumberDM') && $this.data('animateNumberDM')) {
                        $this.data('randomNumberDM')();
                        $this.data('animateNumberDM')();
                        $this.data('hasAnimated', true);
                    }
                });
                el.find('.pin').addClass('active');
            }
            else {
                el.find('.pin').removeClass('active');
            }

        });    
    }
}

$('.retailers .wrapper:not(.main)').on('click', function() {
    let url = $(this).find('a').attr('href');
    if (url) {
        window.open(url, '_blank');
    }
});

function milestone_dates() {
    if ($('.milestones').length) {
        $('.milestones').each(function() {
            let el;

            if (wSize >= 1280) {
                el = $(this).find(':not(.mobile-container)');
            }
            else {
                el = $(this).find('.mobile-container');
            }

            let dateH = el.find('.dates .date').first().height();

            el.find('.dates').css('height', `${dateH + 25}px`);
            
            if (wSize >= 1280) {
                el.find('.line').css('width', '100%');
            } else {
                let dateW = 0;
                let $dates = el.find('.date');

                $dates.each(function() {
                    dateW += $(this).width();
                });

                for (let i = 0; i < $dates.length - 1; i++) {
                    let $current = $($dates[i]);
                    let $next = $($dates[i + 1]);

                    let currentRight = $current.offset().left + $current.outerWidth();
                    let nextLeft = $next.offset().left;

                    let space = nextLeft - currentRight;
                    dateW += space;
                }

                el.find('.line').css('width', `${dateW}px`);
            }
        });
    }
}

function categorized_cat() {
    if ($('.categorized-slider').length) {
        $('.categorized-slider').each(function() {
            let el = $(this);

            if (wSize >= 1280) {
                el.find('.categories .line').css('width', '100%');
            } else {
                let cat = 0;
                let $cats = el.find('.mobile-container .category');
                let gap = parseFloat(el.find('.mobile-container .categories').css('gap')) || 0;

                $cats.each(function(index) {
                    cat += $(this).outerWidth(); // use outerWidth if padding/border included

                    if (index !== $cats.length - 1) {
                        cat += gap;
                    }
                });

                el.find('.mobile-container .categories .line').css('width', `${cat}px`);
            }
        });
    }
}